{
  "customAddress": "Saisir l'adresse personnalisée",
  "title": "<h1>Veuillez confirmer votre adresse.</h1>",
  "subtitle": "<span>Les informations que vous avez fournies ne nous permettent pas de continuer. Veuillez utiliser l'une des adresses proposées ci-dessous ou saisir une adresse personnalisée.</span>",
  "select-option": "<span><strong>Veuillez sélectionner une option :</strong></span>",
  "recommended": "(recommandée)",
  "custom": "Saisir l'adresse personnalisée",
  "inputs": {
    "street_address": {
      "label": "Adresse du domicile",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [
        ["required", "requise"],
        ["minLength2", "non valide"],
        ["notEmail", "non valide"],
        ["notPOBox", "Boîte postale non acceptée", "ignore label"]
      ]
    },
    "city": {
      "label": "Ville",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [
        ["required", "requise"],
        ["minLength2", "non valide"],
        ["notEmail", "non valide"]
      ]
    },
    "region": {
      "label": "Province",
      "isRequired": true,
      "showRequiredIcon": true,
      "placeholder": "Choisir le province",
      "validity": [
        ["required", "requise"],
        ["minLength2", "non valide"],
        ["validRegionCA", "non valide"]
      ]
    },
    "postal_code": {
      "label": "Code postal",
      "isRequired": true,
      "showRequiredIcon": true,
      "mask": "A0A 0A0",
      "placeholder": "55555",
      "validity": [
        ["required", "requise"],
        ["minLength5", "non valide"]
      ],
      "postProcess": "digitCharOnlyString"
    },
    "monthly_housing_cost": {
      "label": "Coûts mensuels de logement",
      "maxLength": "10",
      "isRequired": true,
      "showRequiredIcon": true,
      "placeholder": "5 000 $",
      "symbol": "$",
      "postProcess": "priceInCents",
      "validity": [["required", "requise"]]
    },
    "primary_income_source": {
      "label": "Principale source de revenus",
      "isRequired": true,
      "showRequiredIcon": true,
      "placeholder": "Choisir une option",
      "validity": [["required", "requise"]]
    },
    "occupation": {
      "label": "Profession",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [["required", "requise"]]
    },
    "employment_duration": {
      "label": "Durée avec l’employeur actuel",
      "placeholder": "Choisir une option",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [["required", "requise"]]
    }
  },
  "incomeSources": {
    "salaried": "Salarié",
    "self-employed": "Travailleur indépendant",
    "investments": "Investissements",
    "other": "Autre"
  },
  "employmentDurations": {
    "<1": "Moins d’un an",
    "1-2": "De 1 à 2 ans",
    "3-5": "De 3 à 5 ans",
    ">5": "Plus de 5 ans"
  },
  "submit": "Continuer"
}
